import { gql as n } from "@apollo/client";
const o = n`
  query GetFrontendConfig($input: LangCode) {
    getSystemConfig(input: $input) {
      frontendConfig
    }
  }
`;
export {
  o as default
};
//# sourceMappingURL=getFrontendConfig.js.map
